import { cn } from '../lib/classnames.js';

interface LogoProps {
  className?: string;
}

/**
 * Gilding mark — a single forged-gold serif G with its lockup period.
 * Matches the splash wordmark's gold ramp exactly (same gradient stops as
 * the favicon). No frame, no cartouche: the metal is the identity.
 */
export function Logo({ className }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      role="img"
      aria-labelledby="gilding-logo-title"
      className={cn('gilding-logo', className)}
    >
      <title id="gilding-logo-title">Gilding</title>
      <defs>
        <linearGradient id="gildRamp" x1="0" y1="0" x2="0.3" y2="1">
          <stop offset="0" stopColor="#a87f2c" />
          <stop offset="0.42" stopColor="#e9c873" />
          <stop offset="0.52" stopColor="#fff3ce" />
          <stop offset="0.62" stopColor="#c2922f" />
          <stop offset="1" stopColor="#7d521a" />
        </linearGradient>
      </defs>
      <text
        x="30"
        y="50"
        textAnchor="middle"
        fontFamily="Fraunces, Georgia, serif"
        fontSize="52"
        fontWeight="900"
        fill="url(#gildRamp)"
      >
        G
      </text>
      <circle cx="52" cy="48" r="3.4" fill="url(#gildRamp)" />
    </svg>
  );
}
